import manImg from "../../../assets/images/man.png";
import WomenImg from "../../../assets/images/woman.png";
import kid from "../../../assets/images/children.png";
export const categoryOptions = [
    {
        label: "Men",
        value: "men",
        img: manImg,
    },
    {
        label: "Women",
        value: "women",
        img: WomenImg,
    },
    {
        label: "Kids",
        value: "kids",
        img: kid,
    },
];
